import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Criteria, ExternalMemberService } from "src/app/Service/member/external-member.service";
import { IOrganizationViewModel } from "src/app/ViewModel/OrganizationModel";
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { CommonService } from 'src/app/Service/Common.service';
import { EncryptDecryptService } from "src/app/Service/encrypt-decrypt.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { Module } from 'src/app/Service/element-details.data.service';
import { ProjectWorkflowStatusService } from 'src/app/Service/ProjectWorkflowStatus/ProjectWorkflowStatus.service';
import { ProjectWorkflowStatusOutputModel, ProjectWorkflowStatusInputModel } from 'src/app/ViewModel/ProjectWorkflowStatus';
import { IProjectElementDetailsOutput } from 'src/app/ViewModel/ProjectElementsModel';


@Component({
    selector: 'app-project-workflow-status-dialog',
    templateUrl: './project-workflow-status-dialog.component.html',
    styleUrls: ['./project-workflow-status-dialog.component.css']
})
export class EditprojectworkflowstatusComponent implements OnInit {
    public stageList: any[] = [];
    public stageTypeList: any[] = [];
    public projectId: number;
    public groupId: number;
    public dedId!:number|null;
    public status_TypeId !:number|null;
    public InsertFlag : boolean = true;
    isValidLntUser: boolean = false;
    hide: boolean = true;
    criteriaMap = new Map<Criteria, RegExp>();
    customValidators: Criteria[]|any = Object.keys(Criteria).map((key:any) => Criteria[key]);
    _is8Characters!: boolean;
    _isSymbols!: boolean; 
    _isComplexWord!: boolean;
    isEditUser: boolean = false;
    selectedOption: string = 'ltMember';
    isInternalUser: boolean = true;
    public actionButtonText: string = "Save";
    memberId!: number ;
    psNo: FormControl = new FormControl('', [Validators.required, Validators.maxLength(15), Validators.pattern('^[0-9]*$')])
    public PWorkflowStatus!: FormGroup;
    businessGroups: IOrganizationViewModel[] = [];
    selectedGroup: any;
    /**Member Details array */
    ProjectWorkflowStatusList!: ProjectWorkflowStatusOutputModel;
    constructor(private _projInfoService: ProjectInfoService,public _dialogRef: MatDialogRef<EditprojectworkflowstatusComponent>, public _formBuilder: FormBuilder,  private _commonService: CommonService,
        @Inject(MAT_DIALOG_DATA) public _data: any, private encryptDecryptService: EncryptDecryptService, private _notificationService: NotificationService
        ,private _projectWorkflowService:ProjectWorkflowStatusService) {
        this.memberId = _data.member;
        this.projectId = _data.project_Id;
        this.groupId = _data.group_Id;
        this.ProjectWorkflowStatusList = _data.ProjectWorkflowobj;
        
    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {   
     
        this.getDropDownValue();  
        this.memberId = this._commonService.getLoggedInUserId();
        this.createForm();
        //this.ProjectWorkflowStatusList=undefined;
        if(this.ProjectWorkflowStatusList)
        {
        this.setFormValues();
        this.InsertFlag = false;
        }
              
        
    }
    createForm() {
        this.PWorkflowStatus = this._formBuilder.group({
            //status: new FormControl([Validators.required]),
            status: new FormControl(),
            statusType: new FormControl(),
            statusOrder: new FormControl(),
            projectStatusDesc: new FormControl(),
            sCurveStatusDesc: new FormControl(),
            isActive: new FormControl(true),
        });
        this.formMarkAsTouched(this.PWorkflowStatus);
    }
    /**
     * Set form values
     */
    setFormValues() {
        this.PWorkflowStatus.get('status')?.setValue(this.ProjectWorkflowStatusList.statusDescription);
        this.dedId =this.ProjectWorkflowStatusList.status_Id;
        this.PWorkflowStatus.get('statusType')?.setValue(this.ProjectWorkflowStatusList.statusTypeDesc);
        this.status_TypeId =this.ProjectWorkflowStatusList.status_Type;    
        this.PWorkflowStatus.get('projectStatusDesc')?.setValue(this.ProjectWorkflowStatusList.projectStatusDesc);
        this.PWorkflowStatus.get('sCurveStatusDesc')?.setValue(this.ProjectWorkflowStatusList.sCurveStatusDesc);
        this.PWorkflowStatus.get('isActive')?.setValue(this.ProjectWorkflowStatusList.isActive);
        this.PWorkflowStatus.get('statusOrder')?.setValue(this.ProjectWorkflowStatusList.status_Order);
       
    }

    formMarkAsTouched(form: any|FormGroup) {
        if (form.valid)
            Object.keys(form.controls).forEach(key => {
                form.get(key).markAsTouched();
            });
    }

    /**
     * Save member details
     */
    save() {
        let _input: ProjectWorkflowStatusInputModel= {
        project_Id : this.projectId,
        group_Id : this.groupId,
        status_Id : this.dedId,
        status_Type : this.status_TypeId,
        status_Order : this.getFormValue('statusOrder'),
        projectStatusDesc : this.getFormValue('projectStatusDesc'),
        sCurveStatusDesc : this.getFormValue('sCurveStatusDesc'),
        isActive : this.getFormValue('isActive'),
        member_Id : this.memberId,
        insertFlag : this.InsertFlag
        }
        this._projectWorkflowService.postProjectWorkflowStatus(_input).subscribe((res: StandardOutputModel) => {
            if (res.successCode==200) 
                this._dialogRef.close( res );
            else
            {
                this._notificationService.showPopup(res.successMessage, "Warning");
                this.clear();
            }
        }, err => {

        });
    }

    /**
     * Get MemForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.PWorkflowStatus.get(controlName)?.value;
    }

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }

    statusChage(value: any) {
        if (value.value != "-2") { 
          this.dedId = value.additionalValues.additionalValues.dedId;
        } else {
          this.dedId = null;
        }
      }
     statustypeChage(value: any) {
        if (value.value != "-2") { 
          this.status_TypeId = value.additionalValues.additionalValues.status_Type;
        } else {
          this.status_TypeId = null;
        }
      }

    getDropDownValue() { 
        
        this.stageTypeList.push({status_Type:1,Desc:"Scheduled"},{status_Type:2,Desc:"Due"},{status_Type:3,Desc:"Completed"},{status_Type:4,Desc:"Assigned"},{status_Type:5,Desc:"Submision No"})
        this._projInfoService.getProjectElementCascadingDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.Workflow, deDescription: 'Workflow Status' }).subscribe((res: IProjectElementDetailsOutput[]) => {
           res.forEach(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);      
           this.stageList = res;
        });
      
    }
    clear()
    {
        this.PWorkflowStatus.get('status')?.setValue('');
        this.dedId =null;
        this.PWorkflowStatus.get('statusType')?.setValue('');
        this.status_TypeId =null;    
        this.PWorkflowStatus.get('projectStatusDesc')?.setValue('');
        this.PWorkflowStatus.get('sCurveStatusDesc')?.setValue('');
        this.PWorkflowStatus.get('isActive')?.setValue(true);
        this.PWorkflowStatus.get('statusOrder')?.setValue('');
    }


}
